import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "../services/auth.service";
import { LoggingService } from "../services/logging.service";
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {
    LoggingService.log("ErrorInterceptor ctor");
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    LoggingService.log("ErrorInterceptor intercept");
    return next.handle(request).pipe(
      catchError(error => {
        LoggingService.log("ErrorInterceptor error begin");
        if (error.status === 401) {
          LoggingService.log("ErrorInterceptor 401");

          this.authService.logout();
        }

        let errorMessage = "";
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Error Code: ${error.status} - Message: ${error.message}`;
        }

        LoggingService.log(`ErrorInterceptor error end - HTTP ERROR: ${errorMessage}`);

        return throwError(error);
      })
    );
  }
}
